const TIME_ZONES = {
  'America/Los_Angeles': 'LA',
  'Europe/Moscow': 'MSK',
  UTC: 'UTC',
};

export default TIME_ZONES;
